import React from 'react';
import { VideoElement } from './big9/styled';

const Video = ({ src }) => {
    return (
        <VideoElement
            src={src}
            title="Om big 9"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
        />
    );
};

export default Video;
